{
  "modal": {
    "header": "Mapped to"
  },
  "company_industry": "Company Industry",
  "choose_internal_industries": "Choose internal industries to map to",
  "select_internal_industries_placeholder": "Select internal industries"
}
